// extracted by mini-css-extract-plugin
module.exports = {"root":"Location_root__fBurK","addressName":"Location_addressName__ve5nZ","addressDetail":"Location_addressDetail__E_VK_","planeWrapper":"Location_planeWrapper__32x9k"};